import classNames from 'classnames';
import { Trans, useTranslation } from 'next-i18next';

import { sellerSuccessFeeHelpPath } from '@/shared/constants/routes';

import styles from './SecureSales.module.scss';
import { LearnMoreLink } from '../LearnMoreLink';
import { BlockContent, BlockContentProps } from './BlockContent';
import { SellerFixedFeeTiers } from './SellerFixedFeeTiers';
import { StrongBrandContainer } from '../StrongBrandContainer';

export const SecureSales = () => {
  const { t } = useTranslation();

  const blockContent: BlockContentProps[] = [
    {
      title: t('seller_register.secure.prices_title'),
      subtitle: (
        <Trans
          i18nKey="seller_register.secure.prices_subtitle_with_seller_success_fee"
          components={{ span: <span className="u-color-brand" /> }}
        />
      ),
      tooltip: <SellerFixedFeeTiers />,
    },
    {
      title: t('seller_register.secure.fee_title'),
      subtitle: t('seller_register.secure.fee_subtitle'),
    },
    {
      title: t('seller_register.secure.shipping_title'),
      subtitle: t('seller_register.secure.shipping_subtitle'),
    },
  ];

  return (
    <section className="u-m-t-xxl-18">
      <div className="tw:flex tw:justify-between tw:items-center u-m-b-xl">
        <h2 className="u-typography-h2">
          <Trans
            i18nKey="seller_register.secure.title"
            components={{
              strong: (
                <StrongBrandContainer className="u-typography-h2-serif" />
              ),
            }}
          />
        </h2>
        <LearnMoreLink
          className="tw:hidden tw:md:inline-flex"
          text={t('seller_register.learn_more')}
          url={sellerSuccessFeeHelpPath}
        />
      </div>
      <h3 className="u-typography-h3 u-color-secondary u-m-b-xl">
        {t('seller_register.secure.subtitle')}
      </h3>
      <div
        className={classNames(
          styles.list,
          'tw:flex tw:justify-between u-g-xxl-6'
        )}
      >
        {blockContent.map((block) => (
          <BlockContent key={block.title} {...block} />
        ))}
      </div>
      <LearnMoreLink
        className="tw:md:hidden"
        text={t('seller_register.learn_more')}
        url={sellerSuccessFeeHelpPath}
      />
      <h3 className="u-typography-h3 u-m-t-xxl-6 u-m-b-l">
        {t('seller_register.did_you_know.title')}
      </h3>
      <p className="u-color-secondary">
        {t('seller_register.did_you_know.subtitle')}
      </p>
    </section>
  );
};
